webpackJsonp([213534597649335],{

/***/ 190:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HomeTitleModule = __webpack_require__(301);
	
	var _HomeTitleModule2 = _interopRequireDefault(_HomeTitleModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HomeTitle = function (_React$PureComponent) {
	    _inherits(HomeTitle, _React$PureComponent);
	
	    function HomeTitle() {
	        _classCallCheck(this, HomeTitle);
	
	        return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	    }
	
	    HomeTitle.prototype._getRoles = function _getRoles() {
	        var rolesRaw = [];
	        for (var i = 0; i < this.props.roles.length; i++) {
	            rolesRaw.push(_react2.default.createElement(
	                'h2',
	                { key: 'role-'.concat(i.toString()), className: _HomeTitleModule2.default.role },
	                this.props.roles[i]
	            ));
	            if (i < this.props.roles.length - 1) rolesRaw.push(_react2.default.createElement(
	                'span',
	                { key: 'span-'.concat(i.toString()) },
	                '\xB7'
	            ));
	        }
	        return rolesRaw;
	    };
	
	    HomeTitle.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            { className: _HomeTitleModule2.default['home-title'] },
	            _react2.default.createElement(
	                'div',
	                { className: _HomeTitleModule2.default['logo-container'] },
	                _react2.default.createElement(
	                    'svg',
	                    {
	                        className: _HomeTitleModule2.default.logo,
	                        xmlns: 'http://www.w3.org/2000/svg',
	                        width: '507.12',
	                        height: '507.12',
	                        viewBox: '0 0 507.12 507.12'
	                    },
	                    _react2.default.createElement(
	                        'g',
	                        { fill: '#DF003F' },
	                        _react2.default.createElement('circle', { cx: '253.56', cy: '253.56', r: '244.452' }),
	                        _react2.default.createElement('path', { d: 'M253.56 507.12c-67.73 0-131.403-26.375-179.294-74.266C26.376 384.964 0 321.29 0 253.56S26.375 122.157 74.266 74.266C122.156 26.376 185.832 0 253.56 0c67.73 0 131.403 26.375 179.294 74.266 47.892 47.89 74.267 111.565 74.267 179.294s-26.374 131.403-74.266 179.294c-47.89 47.89-111.566 74.266-179.294 74.266zm0-488.905c-62.863 0-121.963 24.48-166.414 68.93-44.45 44.452-68.93 103.552-68.93 166.415 0 62.863 24.48 121.964 68.93 166.414 44.45 44.45 103.55 68.93 166.414 68.93 62.863 0 121.964-24.478 166.415-68.93 44.45-44.45 68.93-103.55 68.93-166.414 0-62.863-24.48-121.963-68.93-166.414-44.452-44.45-103.552-68.93-166.415-68.93z' })
	                    ),
	                    _react2.default.createElement('path', {
	                        fill: '#404041',
	                        d: 'M9.107 253.56h488.905c0 135.007-109.445 244.452-244.452 244.452S9.107 388.567 9.107 253.56z'
	                    }),
	                    _react2.default.createElement(
	                        'g',
	                        null,
	                        _react2.default.createElement('path', {
	                            fill: '#DF003F',
	                            d: 'M405.396 253.56L302.776 430.8l-41.39-71.636L322.3 253.56h-15.006l-53.417 92.608-53.51-92.608H185.35l61.023 105.614-41.313 71.624L102.73 253.56H87.69l111.74 193.488c1.162 2.01 3.308 3.25 5.63 3.25s4.468-1.24 5.63-3.25l43.19-74.88 43.266 74.88c1.16 2.01 3.307 3.25 5.63 3.25s4.467-1.24 5.628-3.25L420.42 253.56h-15.024z'
	                        }),
	                        _react2.default.createElement('path', {
	                            fill: '#404041',
	                            d: 'M102.714 253.56l102.62-177.24 41.39 71.636-60.913 105.604h15.007l53.417-92.608 53.51 92.608h15.015l-61.024-105.614 41.313-71.624L405.38 253.56h15.04L308.677 60.07c-1.16-2.01-3.307-3.25-5.63-3.25s-4.467 1.24-5.628 3.25l-43.192 74.88-43.265-74.88c-1.16-2.01-3.307-3.25-5.63-3.25s-4.467 1.24-5.628 3.25L87.69 253.56h15.024z'
	                        })
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'h1',
	                { className: 'site-title' },
	                this.props.name
	            ),
	            this._getRoles()
	        );
	    };
	
	    return HomeTitle;
	}(_react2.default.PureComponent);
	
	exports.default = HomeTitle;
	module.exports = exports['default'];

/***/ }),

/***/ 301:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"home-title":"src-components-home-title----HomeTitle-module---home-title---3jqPp","role":"src-components-home-title----HomeTitle-module---role---2_uaW","logo-container":"src-components-home-title----HomeTitle-module---logo-container---3ZFsl","logo":"src-components-home-title----HomeTitle-module---logo---1NjUb"};

/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _copy = __webpack_require__(8);
	
	var _copy2 = _interopRequireDefault(_copy);
	
	var _HomeTitle = __webpack_require__(190);
	
	var _HomeTitle2 = _interopRequireDefault(_HomeTitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	    var siteTitle = _copy2.default.siteTitle;
	    var roles = _copy2.default.home.roles;
	
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_HomeTitle2.default, { roles: roles, name: siteTitle })
	    );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-jsx-6b4db00041352dede770.js